import React from "react";

import { Spinner } from "@touchtech/web-baselayer-ui";

import css from "./PendingSpinner.module.css";
import useManagePendingSpinner from "./hooks/useManagePendingSpinner";

type Props = {
  show: boolean;
  offset?: number;
  height?: number | string;
};

const PendingSpinner = ({ show, offset, height }: Props) => {
  const { heightOfTheDrawer, heightOfTheSpinner, t, itemsLoadingAnchorRef } =
    useManagePendingSpinner({ show, offset, height });

  if (!show) return null;

  return (
    <div
      className={css.loaderContainer}
      style={{
        height: heightOfTheSpinner,
      }}
    >
      <div
        style={{
          position: "relative",
          top: `-${heightOfTheDrawer}px`,
        }}
      />

      <div className={css.loader}>
        <Spinner className="text-display-8xl" />
        <span className="text-label-2xl">{t("Searching...")}</span>
      </div>

      <div ref={itemsLoadingAnchorRef} />
    </div>
  );
};

export default PendingSpinner;
